<template>
  <div class="view contentBody"> 
    <div class="search_wrap">
      <el-form :inline="true" :model="listData" class="form-inline">
        <el-form-item label="用户昵称">
	            <el-input v-model="listData.nickname" placeholder="用户昵称"  class="w160" size="small"></el-input>
	      </el-form-item>
        <el-form-item label="联系方式">
	            <el-input v-model="listData.tel" placeholder="联系方式"  class="w160" size="small"></el-input>
	      </el-form-item>
        <el-form-item label="合伙人">
          <el-select class="whd-select" clearable v-model="listData.partner_id" placeholder="请选择合伙人" size="small">
            <el-option
              v-for="(item) in partner_list"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="listData.create_time"
            type="date"
            size="small"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item> 
        <el-form-item>
        <el-button type="primary" size="small" @click="searchData" icon="el-icon-search"></el-button>
        </el-form-item>
      </el-form>
    </div>
   
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
            prop="avatar"
            label="微信头像"
            >
            <template slot-scope="scope">
	            <img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
	            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
              <p>{{scope.row.nickname}}</p>
	          </template>
          </el-table-column>
        <el-table-column prop="tel" label="联系方式"></el-table-column> 
        <el-table-column prop="partner_name" label="合伙人"></el-table-column>
        <el-table-column prop="create_time_text" label="客源创建时间"></el-table-column>
        <el-table-column prop="total_bonus" label="给合伙人贡献分红"></el-table-column>
        <el-table-column prop="month_times" label="月平均消费次数"></el-table-column>
        <el-table-column prop="no_day" label="几天未到店里消费"></el-table-column>

      </el-table>       
    </div>  
    <div class="pag_wrap">
      <el-pagination
        background
        :page-size="page.page_size"
        :current-page="page.current_page"
        layout="total, prev, pager, next"
        :total="page.total"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div>  
   
  </div> 
</template>

<script>

import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "customerRecord", 
  data() {
    return {  
      publisher_list:[],
      tableData: [],
      partner_list: [],
      page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total_rows
      },  
      listData: {
        nickname: '',
        tel: '',
        partner_id: '',
        create_time: '',
        page: 1,
      }    
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    InitFn() {
      this.listData.page = this.page.current_page;
      this.axios
        .post(api.partner_customerList, this.listData)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result.lists;
            this.partner_list = response.data.result.partner_list;  
            this.page.total = response.data.page.total_rows//总条数        
          } 
        })
        .catch(() => {});      
    },
    pageIndexChange(pageindex) {
      this.page.current_page = pageindex;
      this.InitFn();
    },
   //搜索
    searchData(){
      this.listData.page = 1;
      this.InitFn()
    },
    
  }
}
</script>
